import React from "react";
import "./styles.scss";
import SearchIcon from "assets/icons/courses/search.svg";

interface Props
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  onChangeText?: (val: string) => void;
  value?: string | number;
  isSearch?: boolean;
  placeholder?: string;
  isPassword?: boolean;
}

const InputMobile = ({ onChangeText, isSearch, value, placeholder, ...restProps }: Props) => {
  return (
    <div className="mobile-input">
      <input
        placeholder={placeholder || "חיפוש"}
        onChange={(val) => onChangeText && onChangeText(val.target.value)}
        value={value}
        {...restProps}
      />
      {!!isSearch && <img src={SearchIcon} />}
    </div>
  );
};

export default InputMobile;
